import base64 from 'base-64';

const decodeHash = (hash: string) => {
    const withoutSaltHash = hash.substring(1);
    return base64.decode(withoutSaltHash);
};

export default decodeHash;